export const addEvent = (event: string, argName: string, argValue: string): void => {
  const gtmDataLayer = window.dataLayer || [];

  gtmDataLayer.push({
    event,
    [argName]: argValue,
  });
};
